import { Component, OnInit} from '@angular/core';
import { blog, category } from '../shared/models/blog';
import { Router, ActivatedRoute } from '@angular/router';
import { BlogService } from '../shared/services/blog.service';
import {Title,DomSanitizer } from "@angular/platform-browser";
import * as AOS from 'aos';
//jquery declaration
declare var $: any;

@Component({
  selector: 'app-blogdetail',
  templateUrl: './blogdetail.component.html',
  styleUrls: ['./blogdetail.component.css']
})

export class BlogdetailComponent implements OnInit {
  allBlogs: blog[];
  blogs: any=[];
  recentPost: blog[];
  objCategory: category[];
  searchHeading: string = "";
  selectedCategory: any = new Array();
  isSelectedTotal: number = 0;
  


  constructor(
    private service: BlogService,
    public router: Router,
    private activeRoute: ActivatedRoute,
    private titleService: Title,
    private domSanitizerService:DomSanitizer
  ) { }

  async ngOnInit() {
    AOS.init();
    this.topposition();
    this.objCategory = new Array();
    await this.service.getBlogs().then(data => {
      this.allBlogs = data;
      this.recentPost = data;

      this.objCategory.push({
        category: "ALL",
        total: 0,
        checked: true
      });

      const _category = this.allBlogs.filter(
        (thing, i, arr) => arr.findIndex(t => t.category === thing.category) === i
      );

      _category.forEach((value) => {
        this.objCategory.push({
          category: value.category,
          total: 0,
          checked: true
        });
      });

      this.allBlogs.forEach(element => {
        this.selectedCategory.push(element.category);
      });
    })

    await this.activeRoute.params.subscribe(async routeParams => {      
      await this.service.getBlogs().then(Data => {
        this.blogs = Data.filter(x => x.id==routeParams.id)[0];

        //this.domSanitizerService.bypassSecurityTrustHtml(this.blogs.description);
        console.log(this.blogs);
        this.titleService.setTitle(this.blogs.heading +" - SFI Compliance, Inc");
        this.topposition();
      })
    });
  }

  topposition() {

    // if ($('#preloader').length) {
    //   $('#preloader').delay(500).fadeOut('slow', function() {
    //     $(this).remove();
    //   });
    // }
    $('html, body').animate({
      scrollTop: 0
    }, 1000, 'easeInOutExpo');

    return false;
  }


  goToDetailsPage(id: number): void {
    this.router.navigateByUrl("/blogdetail/" + id);
  }

  gotosafetypage() {
    this.router.navigateByUrl("/blog");
  }

  // async search(): Promise<void> {
  //   await this.service.getBlogDetails(0,this.searchHeading).then(data=>{
  //     this.blogs=data;
  //     console.log(this.blogs);
  //   })
  // }

  // async onCheckboxClick(category:string) : Promise<void> {
  //     this.blogs=undefined;
  //     await this.service.getBlogDetails(0,'').then(data=>{
  //       this.blogs=new Array();

  //       if(category==="ALL"){
  //         this.blogs=data;
  //       }
  //       else{
  //         data.forEach(element => {
  //           if(element.category===category){
  //               this.blogs.push(element);
  //           }
  //         });
  //       }
  //     })

  // }

}
